import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import FooterContainer from '../containers/Footer/Footer.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import SmallerCompaniesSection from '../containers/SmallerCompaniesSection/SmallerCompaniesSection.container'
import SmallerCompaniesBySector from '../containers/SmallerCompaniesBySector/SmallerCompaniesBySector.container'
import SmallerCompaniesCompared from '../containers/SmallerCompaniesCompared/SmallerCompaniesCompared.container'
import SmallerCompaniesParticipation from '../containers/SmallerCompaniesParticipation/SmallerCompaniesParticipation.container'

/**
 * The SmallerCompanies's page.
 */
const SmallerCompanies = () => (
  <BrandLayout footer={<FooterContainer margin="0" />}>
    <TopNavbarContainer menuActive={routes.smallerCompanies} />
    <SmallerCompaniesSection />
    <SmallerCompaniesBySector />
    <SmallerCompaniesCompared />
    <SmallerCompaniesParticipation />
  </BrandLayout>
)
export default SmallerCompanies
